export default __webpack_public_path__ + "static/media/NZ.4c7674fe.svg";